import React, {
  Component,
} from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux'
import {
  push, replace
} from 'redux-router'
import Header from '../components/header/Header'
import Footer from '../components/Footer'
import FestivalFloater from '../components/festival/FestivalFloater'
import Cookie from 'js-cookie'
import {
  loadFlatPages,
  fetchLoggedInUser,
  loadBaseState,
  logout,
  doLogoutUser,
  doSignupUser,
  doFBLogin,
  closeLoginFormRequest,
  closeSignupFormRequest
} from '../actions'
import { AUTH_COOKIE_PATH } from '../utils/'
import Snackbar from '../components/Snackbar'
import ReactGA from 'react-ga'
import settings from '../settings'
import { asyncActions } from 'react-async-actions'
import Raven from 'raven-js'
import AuthFormsModal from '../components/AuthFormsModal'

const actionsToFire = (props) => [
  props.loadFlatPages(),
  props.loadBaseState()
]

@connect(
  state => (state), // Can be replaces by mapStateToProps function as well.
  { push, replace,
    fetchLoggedInUser,
    loadBaseState,
    loadFlatPages,
    logout,
    doSignupUser,
    doLogoutUser,
    closeLoginFormRequest,
    closeSignupFormRequest
  }
)
@asyncActions(actionsToFire)
class Root extends Component {
  constructor(props) {
    super(props)
  }

  logView = () => {
    if (typeof(window) !== "undefined") {
      ReactGA.set({ page: window.location.pathname })
      ReactGA.pageview(window.location.pathname)
    }
  }

  componentWillMount() {
    const token = Cookie.get(AUTH_COOKIE_PATH)
    if (token) {
      this.props.fetchLoggedInUser(token.authToken)
    }
    if (settings.raven) {
      Raven.config(settings.raven.dsn, {...settings.raven.config}).install()
    }

    
  }

  componentDidMount() {
    if (typeof(window) !== "undefined") {
      window.scrollTo(0,0)
      ReactGA.initialize(
        settings.GA.code,
        { debug: settings.debug, titleCase: false}
      )
      this.logView()
    } 
  }

  componentWillReceiveProps(nextProps) {
    const { auth, location } = this.props
    const { nextAuth, nextLocation } = nextProps

    if (nextLocation && location.pathname != nextLocation.pathname) {
      this.logView()
    }

    if ((nextAuth && nextAuth.user) && (auth.user != nextAuth.user)) {
      Raven.setUserContext({
        email: nextAuth.user.email,
        verified: nexAuth.user.verified
      })
    }

    const collageWrapper = document.querySelector('header + div .content-wrapper .home-collage');
    const header = document.querySelector('header');
    if (collageWrapper) {
      const width = collageWrapper.offsetWidth;
      // set the width of the header to the width of the collage
      
      header.style.width = width + 'px';
    } 
  }

  render() {
    const { baseState, accessToken, notifications } = this.props
    const pathname = this.props.location.pathname

    let linkPath = this.props.location.pathname
    let linkPathArray = linkPath.split("/")
    let currentPath = linkPathArray.join(' ');

      let wrapper = ""
      if(pathname === "/") {
         wrapper = "homepage"
      } else {
         wrapper = "not-homepage" + currentPath
      }

    let enginesOn = ''
    if(this.props.enginesOn) {
      enginesOn = <div className="enginesOn">
        <img src="/images/ui/engineson.gif" />
      </div>
    }


    let siteHeader = '';
    if(pathname.indexOf('/stories') > 0) {
      siteHeader = <header><div className="headerItems">
        <div className="left"><Link to="/" className="logo">WorldWideWomen</Link></div>
        <div className="right">
          <div className="returnLink"></div>
        </div>
      </div></header>;
    } else {
      siteHeader = <Header location={this.props.location} applyOrganization={this.props.applyOrganization} />;
    }

    const { signup, location, authForm } = this.props

    const authModal = <AuthFormsModal location={location}/>

    return (
      <div className={`${wrapper}`}>
        {siteHeader}
          {enginesOn}
          {this.props.children}
        <footer><Footer browser={this.props.browser} auth={this.props.auth} /></footer>

        <div className="festival-floater-wrapper">
          <FestivalFloater />
        </div>

        <div className="global-survey-button">
          <a target="_blank" href="https://www.surveymonkey.com/r/worldwidewomen">Share your<br />feedback win a prize</a>
        </div>

        <Snackbar snackbar={this.props.snackbar} />

        {authModal}

      </div>
    )
  }
}

export default Root



// WEBPACK FOOTER //
// ./src/containers/Root.jsx